import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  number: '01',
  title: 'Guía Esencial de los Chakras',
  subtitle: 'Sistema completo de chakras explicado de forma práctica y estructurada.',
  description: 'Aprende la anatomía energética completa: los 7 chakras principales, sus funciones, los bloqueos más comunes y cómo trabajarlos con precisión en cada sesión. Una referencia que consultarás en cada práctica.',
  img: 'https://cdn.magicpatterns.com/uploads/iT6CAjpZxzuLT4GuyCD8zZ/20260219_2003_Image_Generation_simple_compose_01khw27er6etw9jp4f5fxpvbws.png',
  value: '$9.900 ARS'
}, {
  number: '02',
  title: 'Guía de Protección Energética',
  subtitle: 'Protocolos profesionales para proteger y limpiar tu energía.',
  description: 'Técnicas esenciales para proteger tu campo energético antes, durante y después de cada sesión. Aprende a mantener tu integridad energética mientras trabajas con otros — fundamental para cualquier practicante profesional.',
  img: 'https://cdn.magicpatterns.com/uploads/ey22RMkHZWf2kLzjVZ2Pcm/20260219_2004_Image_Generation_simple_compose_01khw2agsbf9gvt6rknbkheg31.png',
  value: '$9.900 ARS'
}, {
  number: '03',
  title: 'Colección de Meditaciones Energéticas',
  subtitle: 'Meditaciones guiadas para potenciar práctica y desarrollo espiritual.',
  description: 'Meditaciones guiadas diseñadas para profundizar tu práctica personal, activar y equilibrar tus chakras, y elevar tu vibración como canal de sanación. Herramientas que complementan cada nivel de tu formación.',
  img: 'https://cdn.magicpatterns.com/uploads/abya1u3NRhNhNLGoB63SpW/20260219_2006_Image_Generation_simple_compose_01khw2em1nfzgbmz1svjqvkt53.png',
  value: '$9.900 ARS'
}];
export function BonusSection() {
  return <section className="py-24 bg-[#1e1254] relative overflow-hidden" data-id="element-13">
      {/* Subtle glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-[#6d28d9] blur-[120px] opacity-20 rounded-full pointer-events-none" data-id="element-14" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-15">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-16">
          <div className="inline-flex items-center gap-2 bg-[#d4af37]/10 border border-[#d4af37]/30 rounded-full px-5 py-2 mb-6" data-id="element-17">
            <Gift className="w-4 h-4 text-[#d4af37]" data-id="element-18" />
            <span className="text-[#d4af37] text-sm font-bold tracking-widest uppercase" data-id="element-19">
              Incluido Gratis con Cualquier Combo
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-20">
            3 Bonus que Potencian Tu Formación
          </h2>
          <p className="text-lg text-purple-200 font-light" data-id="element-21">
            Recursos complementarios diseñados para que puedas aplicar lo
            aprendido desde el primer día.
          </p>
        </div>

        {/* Bonus Cards */}
        <div className="space-y-8 max-w-5xl mx-auto" data-id="element-22">
          {bonuses.map((bonus, i) => <motion.div key={i} className="flex flex-col sm:flex-row items-center sm:items-start gap-8 bg-[#0f0a2e]/60 border border-purple-800/50 rounded-xl p-6 sm:p-8 hover:border-[#d4af37]/40 transition-colors duration-300" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.12
        }} data-id="element-23">
              {/* Book Image */}
              <div className="flex-shrink-0 relative" data-id="element-24">
                <div className="absolute inset-0 bg-violet-500 blur-2xl opacity-20 rounded-full" data-id="element-25" />
                <img src={bonus.img} alt={bonus.title} className="relative w-28 sm:w-36 shadow-xl rounded-sm" data-id="element-26" />
              </div>

              {/* Content */}
              <div className="flex-1 text-center sm:text-left" data-id="element-27">
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-3" data-id="element-28">
                  <span className="text-[#d4af37] font-bold text-xs tracking-[0.2em] uppercase" data-id="element-29">
                    Bonus {bonus.number}
                  </span>
                  <span className="hidden sm:block text-purple-700" data-id="element-30">—</span>
                  <span className="text-purple-400 text-xs line-through" data-id="element-31">
                    Valor: {bonus.value}
                  </span>
                  <span className="inline-block bg-green-500/20 text-green-400 text-xs font-bold px-2 py-0.5 rounded-full border border-green-500/30" data-id="element-32">
                    GRATIS
                  </span>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-1" data-id="element-33">
                  {bonus.title}
                </h3>
                <p className="text-[#d4af37] text-xs font-medium mb-3 italic" data-id="element-34">
                  {bonus.subtitle}
                </p>
                <p className="text-purple-200 font-light leading-relaxed text-sm sm:text-base" data-id="element-35">
                  {bonus.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Total value callout */}
        <motion.div className="mt-12 text-center" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} data-id="element-36">
          <p className="text-purple-300 text-base" data-id="element-37">
            Valor total de los bonus:{' '}
            <span className="line-through text-purple-400" data-id="element-38">$29.700 ARS</span>{' '}
            <span className="text-[#d4af37] font-bold text-lg" data-id="element-39">
              Incluidos gratis en tu combo
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}